import axios from 'axios';
import { API_URL } from './ApiConfig';

const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const requestPasswordReset = async (email: string): Promise<{ message: string }> => {
    const response = await apiClient.post('/auth/forgot-password', { email });
    return response.data;
};

export const resetPassword = async (
    email: string,
    token: string,
    password: string,
    password_confirmation: string
): Promise<{ message: string }> => {
    const response = await apiClient.post('/auth/reset-password', {
        email,
        token,
        password,
        password_confirmation,
    });
    return response.data;
};
